// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  loginBaseURL: "https://rehau-free.cidaas.de",
  client_id: "b7f0ac42-647c-41ed-a91d-5dcc967c1199",
  redirect_url: "/rehau-ui/dashboard",
  auth_request_redirect: "https://rehau-free.cidaas.de/authz-srv/authz?response_type=code&scope=openid%20email%20phone&client_id=b7f0ac42-647c-41ed-a91d-5dcc967c1199&state=af0ifjsldkj&redirect_uri=https://dev.k-box.io&view_type=login" // When used as entrypoint
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
